module.exports = __webpack_public_path__ + "a725497524525c361f0d545e4e8ec577.woff2";